const locale = {
  valid: "válido até",
};

const placeholders = {
  name: "seu nome aqui",
};

export { locale, placeholders };
